import BaseContainer from './component.styles.js'
export default BaseContainer
